import { styled } from 'styled-components'

export const LabelWrapper = styled.div`
    position: absolute;
    top: 2px;
    right: 0;
`
